<div class="flex flex-col gap-4" [formGroup]="formGroup()">
  <div class="grid gap-4 md:grid-cols-2">
    <div class="flex flex-col gap-1">
      <input
        class="flex h-12 items-center rounded-md bg-neutral-50 px-4 py-3 placeholder:text-secondary-text hover:bg-neutral-100 focus:border-1 focus:border-gray-400 focus:bg-white focus:outline-none"
        [attr.aria-invalid]="firstNameControl().invalid"
        [ngClass]="{
          'border-1 border-red-700':
            firstNameControl().touched && firstNameControl().invalid,
        }"
        [placeholder]="'common.fieldPlaceholder.firstName' | translate"
        formControlName="first_name"
        type="text"
      />
      <div
        class="overflow-hidden text-sm text-red-700 transition-all"
        [ngClass]="
          firstNameControl().touched && firstNameControl().invalid
            ? 'h-auto'
            : 'h-0'
        "
        role="alert"
      >
        @if (firstNameControl().errors?.['required']) {
          <span>{{ 'common.fieldValidation.required' | translate }}</span>
        }
      </div>
    </div>

    <div class="flex flex-col gap-1">
      <input
        class="flex h-12 items-center rounded-md bg-neutral-50 px-4 py-3 placeholder:text-secondary-text hover:bg-neutral-100 focus:border-1 focus:border-gray-400 focus:bg-white focus:outline-none"
        [attr.aria-invalid]="lastNameControl().invalid"
        [ngClass]="{
          'border-1 border-red-700':
            lastNameControl().touched && lastNameControl().invalid,
        }"
        [placeholder]="'common.fieldPlaceholder.lastName' | translate"
        formControlName="last_name"
        type="text"
      />
      <div
        class="overflow-hidden text-sm text-red-700 transition-all"
        [ngClass]="
          lastNameControl().touched && lastNameControl().invalid
            ? 'h-auto'
            : 'h-0'
        "
        role="alert"
      >
        @if (lastNameControl().errors?.['required']) {
          <span>{{ 'common.fieldValidation.required' | translate }}</span>
        }
      </div>
    </div>
  </div>

  <div class="flex flex-col gap-1">
    <input
      class="flex h-12 items-center rounded-md bg-neutral-50 px-4 py-3 placeholder:text-secondary-text hover:bg-neutral-100 focus:border-1 focus:border-gray-400 focus:bg-white focus:outline-none"
      [attr.aria-invalid]="usernameControl().invalid"
      [ngClass]="{
        'border-1 border-red-700':
          usernameControl().touched && usernameControl().invalid,
      }"
      [placeholder]="'pages.auth.placeholder.email' | translate"
      formControlName="username"
      type="email"
    />
    <div
      class="overflow-hidden text-sm text-red-700 transition-all"
      [ngClass]="
        creationFailed() ||
        (usernameControl().touched && usernameControl().invalid)
          ? 'h-auto'
          : 'h-0'
      "
      role="alert"
    >
      @if (usernameControl().errors?.['required']) {
        <span>
          {{ 'pages.auth.errors.usernameRequired' | translate }}
        </span>
      }
      @if (usernameControl().errors?.['email']) {
        <span>
          {{ 'pages.auth.errors.emailInvalid' | translate }}
        </span>
      }
      @if (creationFailed()) {
        <span>
          {{ 'pages.auth.errors.creationFailed' | translate }}
          <a class="underline" [routerLink]="['/auth/forgot-password']">{{
            'pages.auth.errors.creationFailedForgotPassword' | translate
          }}</a
          >.
        </span>
      }
    </div>
  </div>

  <div class="relative">
    <input
      class="w-full rounded-md bg-neutral-50 px-4 py-3 placeholder:text-secondary-text hover:bg-neutral-100 focus:border-1 focus:border-gray-400 focus:bg-white focus:outline-none"
      #password
      [placeholder]="'pages.auth.resetPassword.placeholder.new' | translate"
      autocomplete="new-password"
      formControlName="password"
      type="password"
    />
    <button
      class="absolute top-1/2 right-3 -translate-y-1/2 cursor-pointer p-1"
      (click)="
        password.type = password.type === 'password' ? 'text' : 'password'
      "
      type="button"
    >
      <img alt="" height="24" ngSrc="assets/icons/show.svg" width="24" />
    </button>
  </div>

  <div class="relative">
    <input
      class="w-full rounded-md bg-neutral-50 px-4 py-3 placeholder:text-secondary-text hover:bg-neutral-100 focus:border-1 focus:border-gray-400 focus:bg-white focus:outline-none"
      #confirmPassword
      [placeholder]="'pages.auth.resetPassword.placeholder.confirm' | translate"
      autocomplete="new-password"
      formControlName="confirmPassword"
      type="password"
    />
    <button
      class="absolute top-1/2 right-3 -translate-y-1/2 cursor-pointer p-1"
      (click)="
        confirmPassword.type =
          confirmPassword.type === 'password' ? 'text' : 'password'
      "
      type="button"
    >
      <img alt="" height="24" ngSrc="assets/icons/show.svg" width="24" />
    </button>
  </div>

  <dhp-password-requirements
    [requirements]="requirements()"
  ></dhp-password-requirements>
</div>
